// extracted by mini-css-extract-plugin
export var cardHeader = "_di-0";
export var reorderHandle = "_di-3";
export var titleArea = "_di-1";
export var titleAreaWithHandle = "_di-2";